import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'components/core/Typography';
import { CreditCards } from 'components/facility/CreditCards';

import './CreditCardsCard.scss';

export function CreditCardsCard({ cards }) {
	return (
		<div className="card">
			<div className="card-header">
				<Text size="small">Credit Cards Accepted</Text>
			</div>
			<div className="card-block">
				<div className="credit-cards">
					<CreditCards cards={cards} />
				</div>
			</div>
		</div>
	);
}

CreditCardsCard.propTypes = {
	cards: PropTypes.arrayOf(PropTypes.string),
};

export default CreditCardsCard;
